import type { Components } from '@mui/material/styles';

export default function MuiNativeSelect(): Components['MuiNativeSelect'] {
  return {};
}
